import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { appRoutingProviders } from './app.routes';
import { LoadingCirculoComponent } from './shared/components/loading-circulo/loading-circulo/loading-circulo.component';
import { FormatarDataModule } from './shared/pipes/formatar-data/formatar-data.module';
import { CharonHttpService, CharonModule } from '@quickweb/connect-angular';
import { IdsIconComponent, IdsSnackbarModule } from '@ids/angular';
import { FormatDatePipe } from './shared/pipes/formatar-data/formatar-data.service';
import { StatesService } from './abertura-conta/config/service/states/states.service';
import { StateDadosProponenteTradicionalService } from './abertura-conta/config/service/state-dados-proponente-tradicional/state-dados-proponente-tradicional.service';
import { RequestCaronteService } from './abertura-conta/config/service/request-caronte/request-caronte.service';
import { DominioQaService } from './abertura-conta/config/service/dominio-qa/dominio-qa.service';
import { NotificacaoService } from './abertura-conta/config/service/notificacao/notificacao.service';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    LoadingCirculoComponent,
    FormatarDataModule,
    CharonModule.withConfig({
      provider: CharonHttpService,
      payloadCryptography: {
        initSessionUrl: environment.baseCharonUrl
      }
    }),
    IdsSnackbarModule,
    IdsIconComponent,
  ],
  providers: [
    appRoutingProviders,
    CharonHttpService,
    RequestCaronteService,
    FormatDatePipe,
    StatesService,
    StateDadosProponenteTradicionalService,
    DominioQaService,
    NotificacaoService,
  ],
  exports: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
